export default "__VITE_ASSET__C0z4fxuP__"